import styles from './style.postcss';

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Linkify from 'linkifyjs/react';
import { Icon } from 'omni-common-ui';
import Checkbox from 'components/Checkbox';
import PropTypes from 'prop-types';

export default class SkillRecommendationExpandPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { isExpand: false };
    this._changeExpandState = this._changeExpandState.bind(this);
  }

  _changeExpandState() {
    this.setState({ isExpand: ! this.state.isExpand });
  }

  _isChecked(recommendationItemId) {
    const { selectedRecommendationItemIds } = this.props;
    return selectedRecommendationItemIds.includes(recommendationItemId);
  }

  _isDisabled(recommendationItemId) {
    const { isSSV3Group, selectedRecommendationItemIds } = this.props;
    return isSSV3Group &&
      selectedRecommendationItemIds.length >= 3 &&
      ! selectedRecommendationItemIds.includes(recommendationItemId);
  }

  _checkRecommendationItem(id) {
    this.props.checkRecommendationItem(id);
  }

  _renderRecommendationItem(recommendationItem) {
    const isDisabled = this._isDisabled(recommendationItem.id);
    const checkRecommendationItem = this._checkRecommendationItem.bind(this, recommendationItem.id);
    return <label htmlFor={recommendationItem.id}
        className={styles.SkillRecommendationExpandPanel_item}
        key={recommendationItem.id}>
      <Checkbox id={recommendationItem.id}
          checked={this._isChecked(recommendationItem.id)}
          onChange={checkRecommendationItem}
          disabled={isDisabled} />
      <Linkify disabled={isDisabled}>{recommendationItem.itemName}</Linkify>
    </label>;
  }

  render() {
    const { categoryName, recommendationItems } = this.props;
    const { isExpand } = this.state;
    const iconClassName = classnames(styles.SkillRecommendationExpandPanel_header_arrow, {
      [styles.__expanded]: isExpand,
    });
    return <div className={styles.SkillRecommendationExpandPanel_wrapper}>
      <div className={styles.SkillRecommendationExpandPanel_header} // eslint-disable-line
          onClick={this._changeExpandState}>
        <label className={styles.SkillRecommendationExpandPanel_category}>{categoryName}</label>
        <Icon id="chevron-small-down" className={iconClassName} />
      </div>
      {isExpand && recommendationItems.map((recommendationItem) =>
          this._renderRecommendationItem(recommendationItem))}
    </div>;
  }
}
SkillRecommendationExpandPanel.propTypes = {
  isSSV3Group: PropTypes.bool,
  categoryName: PropTypes.string,
  recommendationItems: PropTypes.shape(),
  checkRecommendationItem: PropTypes.func,
  selectedRecommendationItemIds: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
};



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/FeedbackSuggestions/SkillSuggestionCard/SkillRecommendation/SkillRecommendationExpandPanel/index.jsx